<i18n>
{
  "fr": {
    "tab-infos": "Informations sur l'entreprise",
    "tab-users": "Utilisateurs",

    "manage-business-title": "Réglages",
    "manage-business-category": "Type d'entreprise",
    "manage-business-status": "Statut",
    "manage-business-jurisdiction": "Juridiction",
    "manage-business-subscription-date": "Date d'abonnement",
    "manage-business-add-user": "Ajouter un utilisateur",
    "manage-business-user-name": "Nom",
    "manage-business-user-position": "Titre",
    "manage-business-user-type": "Rôle",
    "manage-business-user-email": "Courriel",
    "manage-business-user-email-link": "Courriel",
    "manage-business-user-unconfirmed-email": "Compte non confirmé",
    "manage-business-user-last-login": "Dernière connexion",
    "manage-business-user-last-login-tooltip": "Correspond à la dernière connexion du compte à la plateforme Core. Puisque certains comptes peuvent être associés à plus d'une entreprise, il ne s'agit pas nécessairement de la dernière connexion à «{name}».",

    "manual-display-name": "Nom d'affichage de l'entreprise pour le manuel",
    "manual-display-name-empty": "(Aucun)",

    "remove-user-title": "Retirer l'utilisateur",
    "remove-user-message": "Êtes-vous certain de vouloir retirer «\u00A0{firstName} {lastName}\u00A0» de cette entreprise\u00A0?",
    "remove-user-message-indicators": "Êtes-vous certain de vouloir retirer «\u00A0{firstName} {lastName}\u00A0» de cette entreprise\u00A0?<br/><br/>Cette personne est présentement responsable {indicatorCount, plural, one {<strong>d'un indicateur</strong> qui se retrouvera} other {<strong>de # indicateurs</strong> qui se retrouveront}} sans responsable à la suite de cette opération.",
    "remove-user-cancel": "Annuler",
    "remove-user-confirm": "Retirer",
    "remove-user-applicant-error": "Vous ne pouvez pas retirer le requérant d'une entreprise.",

    "applicant-tooltip" : "Requérant de l'entreprise",
    "change-applicant-title" : "Changer le requérant",
    "change-applicant-message":"Êtes-vous certain de vouloir transférer le rôle de requérant à «\u00A0{firstName} {lastName}\u00A0» pour cette entreprise\u00A0? L'ancien requérant de l'entreprise conservera le rôle d'Administrateur après cette modification.",
    "change-applicant-cancel" : "Annuler",
    "change-applicant-confirm" : "Confirmer",
    "change-applicant-success" : "Transfert de requérant complété",

    "resend-invite-tooltip":"Renvoyer l'invitation",
    "resend-invite-title": "Renvoyer le courriel d'invitation",
    "resend-invite-message": "Êtes-vous certain de vouloir renvoyer le courriel d'invitation à l'adresse «\u00A0{email}\u00A0»\u00A0?",
    "resend-invite-cancel" : "Annuler",
    "resend-invite-confirm" : "Confirmer",
    "resend-invite-success" : "Courriel d'invitation envoyé",

    "upload-label": "Faites glisser et déposez votre fichier ici, ou cliquez pour <u class='has-text-link'>choisir un fichier</u>",
    "clear-logo": "Supprimer",
    "clear-logo-title": "Supprimer le logo",
    "clear-logo-message": "Êtes-vous certain de vouloir supprimer le logo de votre entreprise\u00A0?",
    "clear-logo-confirm": "Supprimer",
    "clear-logo-cancel": "Annuler",

    "informations-title": "Informations",
    "informations-business-description": "Description de l'entreprise",
    "informations-projects-description": "Description des projets actifs",
    "informations-manual-application": "Application du manuel",
    "informations-edit": "Modifier les informations"
  },
  "en": {
    "tab-infos": "Company details",
    "tab-users": "Users",

    "manage-business-title": "Settings",
    "manage-business-category": "Company type",
    "manage-business-status": "Status",
    "manage-business-jurisdiction": "Jurisdiction",
    "manage-business-subscription-date": "Subscription date",
    "manage-business-add-user": "Add user",
    "manage-business-user-name": "Full name",
    "manage-business-user-position": "Position",
    "manage-business-user-type": "Role",
    "manage-business-user-email": "Email",
    "manage-business-user-email-link": "Email",
    "manage-business-user-unconfirmed-email": "Unconfirmed account",
    "manage-business-user-last-login": "Last login",
    "manage-business-user-last-login-tooltip": "Represents the account's last connection to the Core platform. Since some accounts may be associated with more than one company, this is not necessarily the last connection to \"{name}\".",

    "manual-display-name": "Display name of the company for the manual",
    "manual-display-name-empty": "(None)",

    "remove-user-title": "Remove user",
    "remove-user-message": "Are you sure that you want to remove \"{firstName} {lastName}\" from this company?",
    "remove-user-message-indicators": "Are you sure that you want to remove \"{firstName} {lastName}\" from this company?<br/><br/>This person is currently assigned to {indicatorCount, plural, one {<strong>one indicator</strong>} other {<strong># indicators</strong>}} which will be unassigned after this operation.",
    "remove-user-cancel": "Cancel",
    "remove-user-confirm": "Remove",
    "remove-user-applicant-error": "You cannot remove the applicant of a business.",

    "applicant-tooltip" : "Company's applicant",
    "change-applicant-title" : "Change applicant",
    "change-applicant-message":"Are you sure that you want transfer the applicant role to \"{firstName} {lastName}\" from this company? The previous applicant will keep its Administrator role after this operation.",
    "change-applicant-cancel" : "Cancel",
    "change-applicant-confirm" : "Confirm",
    "change-applicant-success" : "Applicant role transfer completed",

    "resend-invite-tooltip":"Resend invite",
    "resend-invite-title": "Resend invite email",
    "resend-invite-message": "Are you sure that you want to resend the invite email to \"{email}\"?",
    "resend-invite-cancel" : "Cancel",
    "resend-invite-confirm" : "Resend",
    "resend-invite-success" : "Invite email sent",

    "upload-label": "Drag and drop your file here, or click to <u class='has-text-link'>choose a file</u>",
    "clear-logo": "Delete",
    "clear-logo-title": "Delete logo",
    "clear-logo-message": "Are you sure you want to delete your company's logo?",
    "clear-logo-confirm": "Delete",
    "clear-logo-cancel": "Cancel",

    "informations-title": "Informations",
    "informations-business-description": "Company description",
    "informations-projects-description": "Active projects description",
    "informations-manual-application": "Application of the manual",
    "informations-edit": "Edit informations"
  }
}
</i18n>

<template>
  <div>
    <h1
      class="title is-2 has-text-weight-bold"
      :class="{
        'mb-24px': $media.mobile,
        'mb-32px': $media.tablet,
        'mb-40px': $media.widescreen
      }"
    >
      {{ $t('manage-business-title') }}
    </h1>

    <b-tabs v-model="activeTab">
      <b-tab-item :label="$t('tab-infos')" value="infos">
        <div class="card mt-24px">
          <ui-box>
            <s-loader :active="!business && $apollo.queries.infos.loading" />
            <attribute-list
              v-if="business"
              class="has-max-width-768"
              :title="business.name"
              :attributes="[
                { label: $t('manage-business-category'), value: businessCategory },
                { label: $t('manage-business-subscription-date'), value: businessSubscriptionDate },
                { label: $t('manage-business-jurisdiction'), value: businessJurisdiction },
                { label: $t('manage-business-status'), value: businessStatus }
              ]"
            />

            <div class="mt-8px" v-if="business">
              <strong class="has-text-weight-semibold">{{ $t('manual-display-name') }}</strong>
              <editable-field
                :value="business.manualDisplayName"
                @save="({ value, closeEditor }) => saveManualDisplayName(value, closeEditor)"
              >
                <span v-if="business.manualDisplayName">{{ business.manualDisplayName }}</span>
                <em v-else>{{ $t('manual-display-name-empty') }}</em>

                <template v-slot:editor="editor">
                  <b-input :value="editor.model" @input="(v) => editor.update(v)" v-focus class="mb-4px" />
                </template>
              </editable-field>
            </div>
          </ui-box>
        </div>
        <div class="card mt-24px" v-if="business">
          <ui-box>
            <h2 class="title is-3 has-text-weight-bold">{{ $t('informations-title') }}</h2>
            <prismic-content :doctype="DOCUMENT_TYPE_MANAGE_BUSINESS" v-slot="{ content }">
              <editable-field
                :value="business"
                @save="({ value, closeEditor }) => saveBusinessInfos(value, closeEditor)"
                :edit-label="$t('informations-edit')"
              >
                <h3 class="title is-4 has-text-weight-bold">{{ $t('informations-business-description') }}</h3>
                <div
                  v-if="$format.stripHtml(business.businessDescriptionRichText)"
                  class="content is-custom"
                  v-html="business.businessDescriptionRichText"
                />
                <div v-else class="content">
                  <prismic-rich-text
                    class="has-max-width-768 business-detail-prismic-rt"
                    :field="content.business_description_placeholder"
                  />
                </div>

                <h3 class="title is-4 has-text-weight-bold">{{ $t('informations-projects-description') }}</h3>
                <div
                  v-if="$format.stripHtml(business.activeProjectsDescriptionRichText)"
                  class="content is-custom"
                  v-html="business.activeProjectsDescriptionRichText"
                />
                <div v-else class="content">
                  <prismic-rich-text
                    class="has-max-width-768 business-detail-prismic-rt"
                    :field="content.projects_description_placeholder"
                  />
                </div>

                <h3 class="title is-4 has-text-weight-bold">{{ $t('informations-manual-application') }}</h3>
                <div
                  v-if="$format.stripHtml(business.manualApplicationRichText)"
                  class="content is-custom"
                  v-html="business.manualApplicationRichText"
                />
                <div v-else class="content">
                  <prismic-rich-text
                    class="has-max-width-768 business-detail-prismic-rt"
                    :field="content.manual_application_placeholder"
                  />
                </div>

                <template v-slot:editor="editor">
                  <h3 class="title is-4 has-text-weight-bold">{{ $t('informations-business-description') }}</h3>
                  <rich-text-editor
                    v-model="editor.model.businessDescriptionRichText"
                    @input="(v) => editor.update({ ...editor.model, businessDescriptionRichText: v })"
                    class="mb-24px"
                  />

                  <h3 class="title is-4 has-text-weight-bold">{{ $t('informations-projects-description') }}</h3>
                  <rich-text-editor
                    v-model="editor.model.activeProjectsDescriptionRichText"
                    @input="(v) => editor.update({ ...editor.model, activeProjectsDescriptionRichText: v })"
                    class="mb-24px"
                  />

                  <h3 class="title is-4 has-text-weight-bold">{{ $t('informations-manual-application') }}</h3>
                  <rich-text-editor
                    v-model="editor.model.manualApplicationRichText"
                    @input="(v) => editor.update({ ...editor.model, manualApplicationRichText: v })"
                    class="mb-24px"
                  />
                </template>
              </editable-field>
            </prismic-content>
          </ui-box>
        </div>
        <div class="card mt-24px" v-if="business">
          <ui-box>
            <div class="content">
              <prismic-content :doctype="DOCUMENT_TYPE_MANAGE_BUSINESS" v-slot="{ content }">
                <prismic-rich-text class="has-max-width-768 business-detail-prismic-rt" :field="content.logo_intro" />
              </prismic-content>
            </div>

            <div class="columns">
              <div class="column">
                <b-field>
                  <b-upload @input="logoSelected" type="is-link" accept="image/jpeg,image/png" drag-drop expanded>
                    <section class="section">
                      <div class="content has-text-centered">
                        <p class="has-text-link">
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p class="is-size-5 has-text-weight-semibold" v-html="$t('upload-label')"></p>
                      </div>
                    </section>
                  </b-upload>
                </b-field>
              </div>
              <div class="column is-flex" v-if="business.logo">
                <div class="manage-business-logo box is-shadowless">
                  <img class="manage-business-logo__img" :src="business.logo.url" />
                  <div class="manage-business-logo__btn">
                    <b-tooltip
                      :label="$t('clear-logo')"
                      type="is-light"
                      size="is-small"
                      :position="$media.tablet ? 'is-left' : 'is-right'"
                    >
                      <button class="button is-small is-outlined" @click="clearLogo">
                        <span class="icon is-small has-text-link"><i class="far fa-trash-alt" /></span>
                      </button>
                    </b-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </ui-box>
        </div>
      </b-tab-item>
      <b-tab-item :label="$t('tab-users')" value="users">
        <div class="card manage-business-user mt-24px">
          <ui-box>
            <div class="content">
              <prismic-content :doctype="DOCUMENT_TYPE_MANAGE_BUSINESS" v-slot="{ content }">
                <prismic-rich-text class="has-max-width-768 business-detail-prismic-rt" :field="content.intro" />
              </prismic-content>
            </div>
            <div v-if="myRole === $consts.enums.BUSINESS_USER_TYPE_BUSINESS_ADMIN">
              <b-button
                type="is-link"
                outlined
                icon-left="plus-circle"
                tag="router-link"
                :to="{ name: $consts.urls.URL_BUSINESS_ADD_USER }"
                >{{ $t('manage-business-add-user') }}</b-button
              >
            </div>
            <div class="mt-24px has-overflow-auto">
              <s-loader :active="!business && $apollo.queries.infos.loading" />
              <b-table v-if="business" :data="business.employees" :loading="$apollo.queries.infos.loading">
                <b-table-column
                  v-slot="props"
                  sortable
                  cell-class="has-text-weight-medium"
                  :custom-sort="sortByName"
                  :label="$t('manage-business-user-name')"
                >
                  {{ props.row.user.profile.firstName }} {{ props.row.user.profile.lastName }}
                </b-table-column>
                <b-table-column v-slot="props" sortable field="position" :label="$t('manage-business-user-position')">
                  {{ props.row.position }}
                </b-table-column>
                <b-table-column v-slot="props" sortable field="userType" :label="$t('manage-business-user-type')">
                  {{ formatBusinessUserType(props.row.userType) }}
                  <b-tooltip
                    v-if="isApplicant(props.row)"
                    :label="$t('applicant-tooltip')"
                    type="is-light"
                    size="is-small"
                    position="is-top"
                  >
                    <b-icon pack="fas" icon="user-tie" size="is-small" type="is-info"></b-icon>
                  </b-tooltip>
                </b-table-column>
                <b-table-column field="user.lastLogin" sortable :label="$t('manage-business-user-last-login')">
                  <template v-slot:header="{ column }">
                    {{ column.label }}
                    <b-tooltip
                      :label="$t('manage-business-user-last-login-tooltip', { name: business.name })"
                      append-to-body
                      type="is-light"
                      size="is-large"
                      position="is-top"
                      multilined
                    >
                      <span class="icon is-small has-text-link"><i class="fas fa-info-circle fa-sm" /></span>
                    </b-tooltip>
                  </template>
                  <template v-slot="props">
                    <span v-if="!!props.row.user.emailConfirmed">
                      {{ !!props.row.user.lastLogin ? $format.dateTime(props.row.user.lastLogin) : '' }}
                    </span>
                    <span v-else class="is-italic">
                      {{ $t('manage-business-user-unconfirmed-email') }}
                    </span>
                  </template>
                </b-table-column>
                <b-table-column v-slot="props" :label="$t('manage-business-user-email')">
                  <a class="has-text-underline" target="_blank" :href="`mailto:${props.row.user.email}`">
                    {{ $t('manage-business-user-email-link') }}
                  </a>
                </b-table-column>
                <b-table-column v-slot="{ row }">
                  <b-field position="is-right">
                    <p class="control">
                      <b-button
                        outlined
                        size="is-small"
                        tag="router-link"
                        :to="{ name: $consts.urls.URL_BUSINESS_EDIT_USER, params: { id: row.user.id } }"
                      >
                        <span class="icon is-small has-text-link"><i class="fas fa-pen" /></span>
                      </b-button>
                    </p>
                    <p class="control">
                      <b-tooltip
                        :active="canBeMadeApplicant(row)"
                        :label="$t('change-applicant-title')"
                        type="is-light"
                        size="is-small"
                        position="is-left"
                      >
                        <b-button outlined size="is-small" @click="transferApplicant(row)" :disabled="!canBeMadeApplicant(row)">
                          <span class="icon is-small has-text-link"><i class="fas fa-user-tie" /></span>
                        </b-button>
                      </b-tooltip>
                    </p>

                    <p class="control">
                      <b-tooltip
                        :active="!row.user.emailConfirmed"
                        :label="$t('resend-invite-tooltip')"
                        type="is-light"
                        size="is-small"
                        position="is-left"
                      >
                        <b-button outlined size="is-small" @click="resendInviteEmail(row)" :disabled="!!row.user.emailConfirmed">
                          <span class="icon is-small has-text-link"><i class="fas fa-envelope" /></span>
                        </b-button>
                      </b-tooltip>
                    </p>

                    <p class="control">
                      <b-button outlined size="is-small" @click="removeEmployee(row)" :disabled="row.user.id === currentUserId">
                        <span class="icon is-small has-text-link"><i class="far fa-trash-alt" /></span>
                      </b-button>
                    </p>
                  </b-field>
                </b-table-column>
              </b-table>
            </div>
          </ui-box>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import BusinessService from '@/services/business'
import JurisdictionService from '@/services/jurisdiction'
import { uploadImage } from '@/services/file-upload'
import { DOCUMENT_TYPE_MANAGE_BUSINESS } from '@/consts/prismic'
import enumsHelper from '@/helpers/enums'
import { BUSINESS_USER_TYPE_BUSINESS_ADMIN } from '@/consts/enums'

import Breadcrumbs from '@/mixins/breadcrumbs'
import AttributeList from '@/components/generic/attribute-list.vue'
import PrismicContent from '@/components/prismic/prismic-content'
import UiBox from '@/components/ui/box'
import EditableField from '@/components/generic/editable-field'
import RichTextEditor from '@/components/generic/rich-text-editor'

export default {
  mixins: [Breadcrumbs],
  components: { AttributeList, PrismicContent, UiBox, EditableField, RichTextEditor },
  data() {
    return {
      activeTab: this.$route.query.tab || 'infos',

      currentUserId: null,
      currentBusinessId: null,
      pageContent: null,
      myRole: null,
      business: null,
      DOCUMENT_TYPE_MANAGE_BUSINESS
    }
  },
  computed: {
    businessStatus() {
      if (!this.business) return '-'
      return enumsHelper.formatBusinessStatus(this.business.status)
    },
    businessSubscriptionDate() {
      if (!this.business) return '-'
      return this.$format.date(this.business.subscriptionDate)
    },
    businessCategory() {
      if (!this.business) return '-'
      return enumsHelper.formatBusinessCategory(this.business.category)
    },
    businessJurisdiction() {
      if (!this.business) return '-'
      return JurisdictionService.getJurisdictionDisplay(this.business.jurisdictionCode, this.business.jurisdictionOther)
    },
    breadcrumbs() {
      return [
        {
          label: this.$t('manage-business-title')
        }
      ]
    },
    initialTab() {
      if (this.$route.query.tab) {
        return parseInt(this.$route.query.tab)
      }
      return 0
    }
  },
  methods: {
    sortByName(a, b, asc) {
      var nameA = a.user.profile.firstName + ' ' + a.user.profile.lastName
      var nameB = b.user.profile.firstName + ' ' + b.user.profile.lastName

      if (nameA === nameB) return 0
      return nameA > nameB ? (asc ? 1 : -1) : asc ? -1 : 1
    },
    formatBusinessUserType: enumsHelper.formatBusinessUserType,
    async removeEmployee(employee) {
      const assignments = await this.$apollo.query({
        query: this.$options.query.EmployeeAssignments,
        variables: {
          businessId: this.currentBusinessId,
          userId: employee.user.id
        },
        fetchPolicy: 'no-cache'
      })
      const assignedIndicators = assignments.data.userBusiness.assignedIndicators.totalCount

      const { result } = await this.$buefy.dialog.confirm({
        title: this.$t('remove-user-title'),
        message:
          assignedIndicators == 0
            ? this.$t('remove-user-message', {
                firstName: employee.user.profile.firstName,
                lastName: employee.user.profile.lastName
              })
            : this.$t('remove-user-message-indicators', {
                firstName: employee.user.profile.firstName,
                lastName: employee.user.profile.lastName,
                indicatorCount: assignedIndicators
              }),
        cancelText: this.$t('remove-user-cancel'),
        confirmText: this.$t('remove-user-confirm'),
        type: 'is-danger',
        hasIcon: assignedIndicators > 0
      })

      if (result === true) {
        await this.$apollo.mutate({
          mutation: this.$options.mutation.RemoveUser,
          variables: {
            businessId: this.currentBusinessId,
            userId: employee.user.id
          }
        })

        this.$success()
      }
    },
    isApplicant(employee) {
      return employee.user.id === this.business.applicant.id
    },
    canBeMadeApplicant(employee) {
      if (!this.business) return false
      const isAdmin = employee.userType === BUSINESS_USER_TYPE_BUSINESS_ADMIN
      return isAdmin && !this.isApplicant(employee)
    },
    async transferApplicant(employee) {
      const { result } = await this.$buefy.dialog.confirm({
        title: this.$t('change-applicant-title'),
        message: this.$t('change-applicant-message', {
          firstName: employee.user.profile.firstName,
          lastName: employee.user.profile.lastName
        }),

        cancelText: this.$t('change-applicant-cancel'),
        confirmText: this.$t('change-applicant-confirm'),
        type: 'is-danger'
      })

      if (result === true) {
        await this.$apollo.mutate({
          mutation: this.$options.mutation.TransferBusinessApplicant,
          variables: {
            businessId: this.currentBusinessId,
            userId: employee.user.id
          }
        })

        this.$success(this.$t('change-applicant-success'))
      }
    },
    async resendInviteEmail(employee) {
      const { result } = await this.$buefy.dialog.confirm({
        title: this.$t('resend-invite-title'),
        message: this.$t('resend-invite-message', {
          email: employee.user.email
        }),

        cancelText: this.$t('resend-invite-cancel'),
        confirmText: this.$t('resend-invite-confirm')
      })

      if (result === true) {
        await this.$apollo.mutate({
          mutation: this.$options.mutation.ResendUserInviteEmail,
          variables: {
            businessId: this.currentBusinessId,
            userId: employee.user.id
          }
        })

        this.$success(this.$t('resend-invite-success'))
      }
    },
    async saveBusinessInfos(infos, callback) {
      await this.$apollo.mutate({
        mutation: this.$options.mutation.UpdateBusiness,
        variables: {
          input: {
            businessId: this.currentBusinessId,
            businessDescriptionRichText: { value: infos.businessDescriptionRichText },
            activeProjectsDescriptionRichText: { value: infos.activeProjectsDescriptionRichText },
            manualApplicationRichText: { value: infos.manualApplicationRichText }
          }
        }
      })

      this.$success()
      if (callback) callback()
    },
    async saveManualDisplayName(name, callback) {
      await this.$apollo.mutate({
        mutation: this.$options.mutation.UpdateBusiness,
        variables: {
          input: {
            businessId: this.currentBusinessId,
            manualDisplayName: { value: name }
          }
        }
      })

      this.$success()
      if (callback) callback()
    },
    async logoSelected(file) {
      const fileId = await uploadImage(file)
      await this.$apollo.mutate({
        mutation: this.$withFragments(this.$options.mutation.SetLogo, this.$options.fragments.BusinessLogo),
        variables: {
          businessId: this.currentBusinessId,
          fileId
        }
      })

      this.$success()
    },
    clearLogo() {
      this.$buefy.dialog.confirm({
        title: this.$t('clear-logo-title'),
        message: this.$t('clear-logo-message'),
        confirmText: this.$t('clear-logo-confirm'),
        cancelText: this.$t('clear-logo-cancel'),
        onConfirm: async () => {
          await this.$apollo.mutate({
            mutation: this.$withFragments(this.$options.mutation.SetLogo, this.$options.fragments.BusinessLogo),
            variables: {
              businessId: this.currentBusinessId,
              fileId: null
            }
          })

          this.$success()
        }
      })
    }
  },
  gqlErrors() {
    return {
      CANNOT_REMOVE_APPLICANT_USER_FROM_BUSINESS: this.$t('remove-user-applicant-error')
    }
  },
  async mounted() {
    const business = await BusinessService.getCurrentBusiness()
    this.currentBusinessId = business.id
  },
  apollo: {
    infos: {
      query() {
        return this.$withFragments(this.$options.query.ManageBusiness_Infos, this.$options.fragments.BusinessLogo)
      },
      variables() {
        return {
          businessId: this.currentBusinessId
        }
      },
      skip() {
        return !this.currentBusinessId
      },
      update(data) {
        if (!data) return
        this.currentUserId = data.me.id
        this.myRole = data.me.userBusiness[0].userType
        this.business = data.business
      }
    }
  },
  watch: {
    activeTab(tab) {
      this.$router.replace({ query: { tab } })
    },
    $route(newRoute) {
      this.activeTab = newRoute.query.tab || 'infos'
    }
  }
}
</script>

<style lang="scss">
.business-detail-prismic-rt {
  h3 {
    font-weight: 700;
  }
}

.manage-business-logo {
  border: 1px solid $grey-light;
  display: flex;
  align-self: stretch;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  position: relative;
  height: 240px;

  @include tablet {
    height: auto;
  }

  &__img {
    position: absolute;
    top: 16px;
    left: 16px;
    height: calc(100% - 32px);
    width: calc(100% - 32px);
    object-fit: scale-down;
    object-position: center;
  }

  &__btn {
    position: absolute;
    top: 8px;
    right: 16px;
  }

  @include desktop {
    &__btn {
      opacity: 0;
    }

    &:hover &__btn {
      opacity: 1;
    }
  }
}

@include desktop {
  .manage-business-user {
    tr {
      .field.has-addons {
        opacity: 0;
      }

      &:hover .field.has-addons {
        opacity: 1;
      }
    }
  }
}
</style>

<graphql>
query ManageBusiness_Infos($businessId: ID!) {
  me {
    id
    userBusiness(businessId: { value: $businessId }) {
      id
      userType
    }
  }
  business(id: $businessId) {
    id
    name
    manualDisplayName
    category
    status
    jurisdictionCode
    jurisdictionOther
    subscriptionDate

    applicant {
      id
    }

    businessDescriptionRichText
    activeProjectsDescriptionRichText
    manualApplicationRichText

    ...BusinessLogo

    employees {
      id
      user {
        id
        email
        emailConfirmed
        lastLogin
        profile {
          id
          firstName
          lastName
        }
      }
      userType
      position
    }
  }
}

query EmployeeAssignments($businessId: ID!, $userId: ID!) {
  userBusiness(businessId: $businessId, userId: $userId) {
    id
    assignedIndicators(limit: 0) {
      totalCount
    }
  }
}

mutation RemoveUser($businessId: ID!, $userId: ID!) {
  removeUserFromBusiness(input: { businessId: $businessId, userId: $userId }) {
    business {
      id
      employees {
        id
      }
    }
  }
}

mutation TransferBusinessApplicant($businessId: ID!, $userId: ID!) {
  transferBusinessApplicant(input: { businessId: $businessId, userId: $userId }) {
    business {
      id
      applicant {
        id
      }
      employees {
        id
      }
    }
  }
}

mutation ResendUserInviteEmail($businessId: ID!, $userId: ID!) {
  resendUserInviteEmail(input: { businessId: $businessId, userId: $userId }) {
    user {
      id
    }
  }
}

mutation SetLogo($businessId: ID!, $fileId: String) {
  updateBusiness(input: { businessId: $businessId, logoFileId: { value: $fileId } }) {
    business {
      id
      ...BusinessLogo
    }
  }
}

mutation UpdateBusiness($input: UpdateBusinessInput!) {
  updateBusiness(input: $input) {
    business {
      id
      manualDisplayName
      businessDescriptionRichText
      activeProjectsDescriptionRichText
      manualApplicationRichText
    }
  }
}
</graphql>
<fragments>
fragment BusinessLogo on BusinessGraphType {
  logo {
    id
    url(format: { width: 500 })
  }
}
</fragments>